import { ActionType, Actions } from '../actions';
import { TutorialState } from '../state';

export const tutorial = (draft = {} as TutorialState, action: ActionType): TutorialState => {
  switch (action.type) {
    case Actions.SET_TUTORIAL:
      draft.isActive = action.payload.isActive;
      return draft;
    default:
      return draft;
  }
};
